import React, {Suspense} from "react";
import {Switch} from "react-router-dom";
import {LayoutSplashScreen, ContentRoute} from "../../../_metronic/layout";
import {CustomersPage as CustomersPageComponent} from './pages/CustomersPage';

export default function CustomersPage() {
    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <Switch>
                <ContentRoute path="/customers" component={CustomersPageComponent} />
            </Switch>
        </Suspense>
    );
}
